import {Outlet, useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {Box, Grid, useTheme} from "@mui/material";
import Header from "../component/Header";
import SideMenu from "../component/SideMenu";
import CustomSnackbar from "../component/CustomSnackbar";
import CircularProgressSvg from "../component/CircularProgressSvg";
import {useCheckSession} from "../../config/globalConfig";
import VerifyCode from "../../stream/authentication/page/VerifyCode";
import {GlobalContext} from "../state/GlobalContextProvider";
import {dialogTypes} from "../state/globalVariables";
import NotAuthorizedDialog from "../../stream/authentication/component/NotAuthorizedDialog";

const HomePage = () => {
    useCheckSession();
    const {globalData} = useContext(GlobalContext);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [showBackground, setShowBackground] = useState(true);
    const navigate = useNavigate();
    useEffect(() => {
        if (!!localStorage.getItem('favoritePath') && window.location.pathname === '/'){
            navigate(localStorage.getItem('favoritePath') as string);
        }
    }, []);

    useEffect(() => {
        setInterval(() => {
            if (window.location.pathname === '/' || window.location.pathname === '/login') {
                setShowBackground(true);
            } else {
                setShowBackground(false);
            }
        }, 100);
    }, []);

    const boxStyle = showBackground ? {
        backgroundImage: window.innerWidth <= 1920 ? 'url("/images/homepage_bg_1920x1200.png")' : 'url("/images/homepage_bg_2960x1440.png")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'right',
        height: '100vh'
    } : {};

    return (
        <Box className={'homepage'} sx={boxStyle}>
            <Grid container>
                <Grid item xs={12}>
                    <Header menuIsOpen={menuIsOpen} setMenuIsOpen={setMenuIsOpen}/>
                </Grid>
                <Grid item xs={'auto'}>
                    <SideMenu menuIsOpen={menuIsOpen} setMenuIsOpen={setMenuIsOpen}/>
                </Grid>
                <Grid item xs>
                    <Box pt={useTheme().spacing(6)}>
                        {globalData?.user?.forceUpdateAuthCode ?
                            <VerifyCode status={'update'}/> :
                            <Outlet/>
                        }
                    </Box>
                </Grid>
            </Grid>
            <CustomSnackbar/>
            <CircularProgressSvg/>
            {globalData.dialog === dialogTypes.forbidden &&
                <NotAuthorizedDialog/>
            }
        </Box>
    );
}

export default HomePage;
